export const UPDATE_PUBLIC_NOTIFICATION_PROP = 'UPDATE_PUBLIC_NOTIFICATION_PROP';

export const GET_PS_STARTING = 'GET_PS_STARTING';
export const GET_PS_FINISHED = 'GET_PS_FINISHED';
export const GET_PS_FAILED = 'GET_PS_FAILED';

export const EDIT_NOTI_STARTING = 'EDIT_NOTI_STARTING';
export const EDIT_NOTI_FINISHED = 'EDIT_NOTI_FINISHED';
export const EDIT_NOTI_FAILED = 'EDIT_NOTI_FAILED';

export const SUBMIT_UNSUBSCRIBE_STARTING = 'SUBMIT_UNSUBSCRIBE_STARTING';
export const SUBMIT_UNSUBSCRIBE_FINISHED = 'SUBMIT_UNSUBSCRIBE_FINISHED';
export const SUBMIT_UNSUBSCRIBE_FAILED = 'SUBMIT_UNSUBSCRIBE_FAILED';



// WEBPACK FOOTER //
// ./src/app/stores/settings/public/constants.js